<template>
	<b-row class="justify-content-center">
		<b-col cols="12" lg="6">
			<b-card>
				<template slot="header">
					<h5>{{user.firstName}} {{user.lastName}}</h5>
				</template>
				<b-row>
					<b-col md="5" lg="4">
						<h6><span class="text-info">Número de Identificación: </span> {{user.legalID}}</h6>
					</b-col>
					<b-col md="5" lg="4">
						<h6><span class="text-info">Correo Electrónico: </span> {{user.email}}</h6>
					</b-col>
					<b-col md="5" lg="4">
						<h6><span class="text-info">Nombre de Usuario: </span> {{user.userName}}</h6>
					</b-col>
				</b-row>
			</b-card>
		</b-col>
	</b-row>
</template>

<script>
	import usersData from './UsersData'

	export default {
		name: 'User',
		data: () => {
			return {
				user: '',
			}
		},
		mounted() {
			this.user = JSON.parse(this.$store.getters.user);
		},
		methods: {
			goBack() {
				this.$router.go(-1)
				// this.$router.replace({path: '/users'})
			}
		}
	}
</script>
